
import $ from "jquery"
import SaveManager from "../manager"

const selector = ".js-save-search-prompt"
// a.k.a
// #btn-save-search-prompt .btn-save-search-prompt

const init = () => {
  // original is body
  // as no dom tree change so it should be save to directly set listener
  // mobile rerender
  $("body").on("click", selector, (e) => {
    e.preventDefault()
    SaveManager.emit("save_click")
  })
}

export default {init}
